import { Box, Typography } from "@mui/material";
import { memo } from "react";

import type { ScoutChatMessage, ScoutTextPart } from "./scoutChatMessage";

export const UserMessage = memo(function UserMessage({ message }: { message: ScoutChatMessage }) {
  const isAbort = message.parts.some((part) => part.type === "abort");
  if (isAbort) {
    return (
      <Box
        data-testid="scout-message"
        data-scout-message-id={message.id}
        data-scout-message-role="user"
        sx={{
          display: "flex",
          justifyContent: "center",
          py: 1,
          px: { xs: 2, sm: 3 },
        }}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            textAlign: "center",
            letterSpacing: 0.2,
            userSelect: "none",
          }}
        >
          User cancelled the response.
        </Typography>
      </Box>
    );
  }

  const textParts = message.parts.filter((part): part is ScoutTextPart => part.type === "text");

  return (
    <Box
      data-testid="scout-message"
      data-scout-message-id={message.id}
      data-scout-message-role="user"
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        py: 1.75,
        px: { xs: 2, sm: 3 },
      }}
    >
      <Box
        sx={{
          maxWidth: "min(600px, 100%)",
          px: 2,
          py: 1.5,
          borderRadius: 3,
          bgcolor: "#7092CF",
          color: "white",
          overflowWrap: "break-word",
        }}
      >
        {textParts.map((part) => (
          <Typography
            key={part.id}
            variant="body1"
            sx={{
              whiteSpace: "pre-wrap",
              lineHeight: 1.58,
              "&:not(:last-of-type)": { mb: 1 },
            }}
          >
            {part.text}
          </Typography>
        ))}
      </Box>
    </Box>
  );
});
UserMessage.displayName = "UserMessage";
